import React from "react";

interface SwitchToggle {
  on: boolean;
  switchCb: (val?: boolean) => void;
  disabled?: boolean;
}

export const SwitchToggle: React.FC<SwitchToggle> = ({ on, switchCb, disabled }) => {
  return (
    <div
      style={{
        width: "36px",
        height: "22px",
        background: on ? "#0B8351" : "rgba(255, 255, 255, 0.2)",
        borderRadius: "15px",
        boxShadow: "inset 0px 2px 4px rgba(25, 25, 25, 0.1)",
        position: "relative",
      }}
      onClick={() => {
        if (disabled) return;
        switchCb();
      }}
    >
      <div
        style={{
          width: "22px",
          height: "22px",
          background: disabled ? "rgba(255, 255, 255, 0.5)" : "#fff",
          borderRadius: "22px",
          position: "absolute",
          top: 0,
          right: on ? 0 : "unset",
          left: !on ? 0 : "unset",
        }}
      ></div>
    </div>
  );
};
